<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="6" lg="11">
        <b-form-group
          :label="$t('tracking.occurrenceType.sequenceNumber')"
          label-for="sequenceNumber"
        >
          <base-input-integer
            id="sequencNumber"
            :placeholder="$t('tracking.occurrenceType.sequenceNumber')"
            :value.sync="model.sequenceNumber"
            :readonly="readonly"
          >
          </base-input-integer>
        </b-form-group>

        <b-form-group
          :label="$t('tracking.occurrenceType.description')"
          label-for="description"
        >
          <b-form-input
            id="descripton"
            type="text"
            :placeholder="$t('tracking.occurrenceType.description')"
            v-model="model.description"
            :readonly="readonly"
          />
          <span class="text-danger" v-if="modelstate['description']">
            {{ modelstate["description"][0] }}
          </span>
        </b-form-group>
        <div v-if="isMasterAdmin">
          <b-form-group
            :label="$t('tracking.occurrenceType.scriptPythonAfterProcess')"
            label-for="description"
          >
            <b-form-textarea
              id="descripton"
              type="text"
              :placeholder="
                $t('tracking.occurrenceType.scriptPythonAfterProcess')
              "
              v-model="model.scriptPythonAfterProcess"
              :readonly="readonly"
            />
            <span
              class="text-danger"
              v-if="modelstate['ScriptPythonAfterProcess']"
            >
              {{ modelstate["ScriptPythonAfterProcess"][0] }}
            </span>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <!-- {{model.customFields}} -->
    <div class="customFIelds">
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <h4>Campos customizados</h4>
          <occurrence-custom-fields
            ref="customField"
            :items="model.customFields"
          >
          </occurrence-custom-fields>
        </b-col>
      </b-row>
    </div>

    <b-container>
      <br />
      <h4>Perfil com Acesso a Ocorrência</h4>
      <div
        class="form-group"
        v-for="row in model.profiles"
        :key="row.profilesId"
      >
        <b-row>
          <b-col md="4">
            <label class="pt-2">{{ row.profileName }}</label>
          </b-col>
          <b-col>
            <cargo-permissions-dropdown :value.sync="row.permissions">
            </cargo-permissions-dropdown>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </b-container>
</template>

<script>
import BaseInputInteger from "@/components_rms/base/BaseInputInteger.vue";
import CargoPermissionsDropdown from "@/components_rms/trackingShippingCompany/occurrenceType/CargoPermissionsDropdown.vue";
import OccurrenceCustomFields from "@/components_rms/trackingShippingCompany/occurrenceType/OccurrenceCustomFields.vue";
export default {
  name: "OccurrenceTypeCrudData",
  directives: {},
  components: {
    BaseInputInteger,
    CargoPermissionsDropdown,
    OccurrenceCustomFields,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },

  data() {
    return {
      isMasterAdmin: ""
    };
  },
  created() {
    this.getUserMaster();
  },
  mounted() {},
  computed: {},
  methods: {
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then((response) => {
          this.isMasterAdmin = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },

  watch: {
    model() {
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.customFIelds {
  width: 1000px !important;
}
</style>

